









import 'flatpickr/dist/flatpickr.css'
// docs https://flatpickr.js.org/examples/#flatpickr-external-elements
import flatPickr from 'vue-flatpickr-component'
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {
    flatPickr,
  },
})
export default class DatePicker extends Vue {

}
